import styled from "styled-components";
import colors from "../../theme/colors";

export default styled.div`
  font-size: 14px;
  color: ${colors.gray};
`;
